import React from 'react';
import '../less/depositCredit.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantages_img_4 from '../img/advantages_img_4.png';
import advantages_img_5 from '../img/advantages_img_5.png';
import additionalCards from '../enums/additional_cards_data.json';
import advantagesItemsData from '../enums/advantages_items.json';
import hero_data from '../enums/hero_data.json';
import BusinessOrder from "../../../../BusinessOrder";
import serviceUsageItems from '../enums/service_usage_items.json';

export default function template() {
    const page = 'deposit-credit-new';
    
    const imagesMap = {
      advantages_img_1,
      advantages_img_2,
      advantages_img_3,
      advantages_img_4,
      advantages_img_5
    };

    const handlersMap = {
      toggleHeroModal: this.toggleModal,
    };

    const advantagesItems = advantagesItemsData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    return (
        <div className="deposit-credit-new">
          <Hero
            data={heroData}
            img={hero_img}
            page={page}
          />
          <div className="content">
            <Advantages
              items={advantagesItems}
              title={'BUSINESS_DEPOSIT_CREDIT_NEW_ADVANTAGES_TITLE'}
            />
            <div className="service-usage">
              <div className="container">
                <h2 className="service-usage__title">{this.l10n('BUSINESS_DEPOSIT_CREDIT_NEW_SERVICE_USAGE_TITLE')}</h2>
                <div className="service-usage__body">
                  {serviceUsageItems.map((item, index) => (
                    <div key={index} className="service-usage__item item-service-usage">
                      <div className="item-service-usage__title">{this.l10n(item.title)}</div>
                      <div className="item-service-usage__text">
                        <button onClick={this.toggleModal}>{this.l10n(item.link)}</button>
                        {this.l10n(item.text)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <AdditionalProduct
              items={additionalCards}
              title={'BUSINESS_DEPOSIT_CREDIT_NEW_ADDITIONAL_PRODUCT_TITLE'}
              page={page}
            />
            <FilesForDownloadNew
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              loader={this.state.loader}
            />
          </div>
          {this.state.showModal && <BusinessOrder attribute="deposit-credit" closeModal={this.toggleModal} />}
        </div>
    );
}
